<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .modal-backdrop(v-if="isShowing")
      .modal(
        style='z-index: 1040; padding-right: 15px; display: block;',
        aria-modal='true',
        v-show="isShowing"
        :class="{'modal-mobile': isMobiled}"
      )

        .modal-dialog(role='document')
          .modal-content
            .modal-header
              h4#defaultModalLabel.title
            .modal-body
              .form-group
                span
                  img.img-thumbnail.m-t-10.cursor-pointer(
                      :src='occurrence.image.url', alt='Occurrence_img',
                      :class="{'size-100': isMobiled, 'size-50': !isMobiled}"
                    )
            .modal-footer
              button.btn.btn-simple.btn-round.waves-effect(@click.prevent="doHide()" type='button') Fechar

    .card
      .header
        h2
          strong Codigo: {{ occurrence.id }}{{ occurrence._code}} -&nbsp; {{ occurrence.created_at}}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'dweller.book.occurrence.edit', params: {id: occurrence.id}}") Editar
      .body
          h6.m-b-15
            | {{ occurrence.user.name }}
          p(style="min-height: 70px; text-align: justify;")
            | {{ occurrence.content.slice(0, 100) }} ...

          .progress-container.l-black
            .progress
              .progress-bar(role='progressbar', aria-valuenow='68', aria-valuemin='0', aria-valuemax='100', style='width: 100%;')
          .row
            .col-12
              p
                button.btn.btn-primary.btn-icon.btn-icon-mini.btn-round(
                  @click.prevent="doShow()"
                  style="float: right;",
                  v-if="occurrence.image"
                )
                  i.zmdi.zmdi-image-o
                button.btn.btn-primary.btn-icon.btn-icon-mini.btn-round(
                  style="float: right;",
                  v-if="occurrence.message.length >= 1"
                  @click.prevent="doShowMessage()")
                  i.zmdi.zmdi-comment-more


</template>
<style scoped>
  .size-100 {
    width: 100%;
  }
  .modal-body {
      min-height: 300px;
      overflow-y: auto;
  }
  .modal-mobile {
      position: fixed;
      top: 0;
      right: -17px;
      bottom: 0;
      left: 36px;
      z-index: 1050;
      display: none;
      overflow: hidden;
      outline: 0;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/book-occurrence/index/components/item.vue